import React from "react"
import { ResponsiveBar } from "@nivo/bar"

type OwnProps = {
  data: BarChartData
}

const constKeys = ["アクティベート", "移転", "発行", "移轉", "發行", "转移", "发行", "激活", "啟動"] as const
const keys = ["アクティベート", "移転", "発行", "移轉", "發行", "转移", "发行", "激活", "啟動"]
type Keys = typeof constKeys[number]

/* eslint-disable no-unused-vars */
type BarChartData = {
  [key in Keys]?: number
} & {
  date: string
}[]
/* eslint-enable no-unused-vars */

const BarChart = ({ data }: OwnProps) => (
  <ResponsiveBar
    data={data}
    keys={keys}
    indexBy="date"
    margin={{ top: 50, right: 30, bottom: 50, left: 30 }}
    padding={0.3}
    colors={{ scheme: "category10" }}
    defs={[
      {
        id: "dots",
        type: "patternDots",
        background: "inherit",
        color: "#38bcb2",
        size: 4,
        padding: 1,
        stagger: true
      },
      {
        id: "lines",
        type: "patternLines",
        background: "inherit",
        color: "#eed312",
        rotation: -45,
        lineWidth: 6,
        spacing: 10
      }
    ]}
    borderColor={{ from: "color", modifiers: [["darker", 1.6]] }}
    axisTop={null}
    axisRight={null}
    axisBottom={{
      tickSize: 5,
      tickPadding: 5,
      tickRotation: 0,
      legend: "",
      legendPosition: "middle",
      legendOffset: 32
    }}
    axisLeft={{
      tickSize: 5,
      tickPadding: 5,
      tickRotation: 0,
      legend: "",
      legendPosition: "middle",
      legendOffset: -40
    }}
    enableLabel={false}
    labelSkipWidth={12}
    labelSkipHeight={12}
    labelTextColor={{ from: "color", modifiers: [["darker", 1.6]] }}
    legends={[
      {
        dataFrom: "keys",
        anchor: "bottom-left",
        direction: "row",
        justify: false,
        translateX: 0,
        translateY: 42,
        itemsSpacing: 2,
        itemWidth: 100,
        itemHeight: 10,
        itemDirection: "left-to-right",
        itemOpacity: 0.85,
        symbolSize: 14,
        effects: [
          {
            on: "hover",
            style: {
              itemOpacity: 1
            }
          }
        ]
      }
    ]}
    animate={true}
    motionStiffness={90}
    motionDamping={15}
  />
)

export default BarChart
